// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://euqswbxgwcbpmdnetphs.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV1cXN3Ynhnd2NicG1kbmV0cGhzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY1NDI5NjIsImV4cCI6MjA1MjExODk2Mn0.o-XYa1s80M7KAuruCDbXnChdQBHNS2EzOLZuColwVR8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});